<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DGDEYz/tc-custom/9781035855636.jpg?1718078973915" alt="This image is the cover for the book From Lagos to London"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Lagos to London
      </h1>
      <p class="bookDescription body article font2">
        <p>From Lagos to London: An African Immigrant’s Guide to Property Prosperity charts a remarkable journey of resilience and triumph. In this captivating memoir, Funmi Anu Bankole takes us on a rollercoaster ride through her life, from the highs of success in the competitive world of real estate to the devastating lows brought on by the global financial crisis of 2007/2008. <br/>Through personal anecdotes and invaluable insights, Funmi reveals the secrets to her incredible bounce-back story. She reveals how she transformed her three-bedroom house into a thriving residential care home for vulnerable individuals and provides a wealth of resources and advice for anyone looking to follow in her footsteps. Whether you dream of entering the property market with a limited deposit or aspire to start a domiciliary care agency, Funmi’s wisdom and experience will guide you every step of the way. This moving and empowering memoir is a beacon of hope for aspiring entrepreneurs, immigrants, and anyone facing adversity on their path to success. Funmi’s journey is a testament to the power of perseverance and the boundless potential within each and everyone of us. Her story is proof that recovery is not a matter of chance but a result of proven principles that anyone can apply for transformative, demonstrable results. Beyond property and business insights, Funmi delves into the impact of mental health on entrepreneurs, helping readers to discover their true selves and unlock their full potential. From Lagos to London is more than just a guide to property investing; it’s a compelling narrative of resilience, hope, and the unwavering belief that no setback is insurmountable. Funmi’s journey will leave you inspired and motivated to pursue your own path to prosperity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Funmi Anu Bankole
      </h2>
      
      <p class="authorDescription body article">Funmi Anu Bankole is a bestselling Nigerian-born entrepreneur and author whose works have gained recognition in the national media and worldwide acclaim from readers. She splits her time between Lagos and London, where she runs several successful businesses and owns a large portfolio of properties. Her primary goal is to positively impact the lives of readers worldwide through her books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d8d45d0